<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b"><a id="page_5">too young to die</a></h3><a id="page_5">
<p class="noindent">“Was this all life was about? The stronger picking on the weaker? Survival of the fittest?”</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?1347f903